import Vue from 'vue'

function injectMicrodataScript (data) {
  if (!data) return

  const existingScript = document.querySelector('script[microdata]')
  if (existingScript) {
    if (existingScript.getAttribute('microdata') === 'true') {
      existingScript.textContent = JSON.stringify(data)
    }

    return
  }

  const script = document.createElement('script')
  script.type = 'application/ld+json'
  script.textContent = JSON.stringify(data)
  script.setAttribute('microdata', 'true')
  document.head.appendChild(script)
}

export default {
  namespaced: true,
  state: {
    data: {}
  },
  getters: {},
  mutations: {
    UPDATE_MICRODATA: (state, data) => {
      state.data = { ...state.data, ...data }
    },
    SET_MICRODATA: (state, data) => {
      state.data = { '@context': 'https://schema.org', ...data }
    },
    ADD_ITEM_TO_COLLECTION: (state, { data, name }) => {
      if (state.data[name] === undefined) {
        Vue.set(state.data, name, [
          data
        ])

        return
      }

      Vue.set(state.data, name, [
        ...state.data[name],
        data]
      )
    },
    ADD_PRODUCT: (state, { data, parentName }) => {
      const name = parentName.split(/(?=[A-Z])/).join(' ').toLowerCase()

      if (state.data.mainEntity === undefined) {
        Vue.set(state.data, 'mainEntity', {
          '@type': 'ItemList',
          'name': document.title,
          'itemListElement': []
        }
        )
      }

      for (const element of state.data.mainEntity.itemListElement) {
        if (element.name === name) {
          Vue.set(element, 'itemListElement', [
            ...element.itemListElement,
            data]
          )

          return
        }
      }

      if (!state.data.mainEntity.itemListElement) {
        Vue.set(state.data.mainEntity, 'itemListElement', [])
      }

      Vue.set(state.data.mainEntity, 'itemListElement', [
        ...state.data.mainEntity.itemListElement,
        {
          '@type': 'ItemList',
          'name': name,
          'itemListElement': [data]
        }
      ])
    },
    ADD_ITEM_TO_LIST: (state, data) => {
      if (state.data.mainEntity === undefined) {
        Vue.set(state.data, 'mainEntity', {
          '@type': 'ItemList',
          'name': document.title,
          'itemListElement': []
        }
        )
      }

      Vue.set(state.data.mainEntity, 'itemListElement', [
        ...state.data.mainEntity.itemListElement,
        data
      ])
    },
    INITIALIZE_START_MICRODATA (state) {
      state.data = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'name': 'DNIPRO-M.PL',
        'url': document.location.href,
        'breadcrumb': window.config.breadcrumbs?.length > 1 ? {
          '@type': 'BreadcrumbList',
          'itemListElement': window.config.breadcrumbs?.map((breadcrumb, index) => {
            return {
              '@type': 'ListItem',
              'position': index + 1,
              'item': {
                '@id': 'https://' + window.location.hostname + breadcrumb.url,
                'name': index === 0 ? 'Dnipro-M Polska' : breadcrumb.label
              }
            }
          })
        } : undefined
      }
    }
  },
  actions: {
    INITIALIZE_MICRODATA: ({ commit, state }) => {
      commit('INITIALIZE_START_MICRODATA')
      injectMicrodataScript(state.data)
    },
    APPEND_ITEM_TO_LIST: ({ commit, state }, data) => {
      commit('ADD_ITEM_TO_LIST', data)
      injectMicrodataScript(state.data)
    },
    APPEND_PRODUCT: ({ commit, state }, data) => {
      commit('ADD_PRODUCT', data)
      injectMicrodataScript(state.data)
    },
    APPEND_ITEM_TO_COLLECTION: ({ commit, state }, data) => {
      commit('ADD_ITEM_TO_COLLECTION', data)
      injectMicrodataScript(state.data)
    },
    UPDATE_MICRODATA_CONTENT: ({ commit, state }, data) => {
      commit('UPDATE_MICRODATA', data)
      injectMicrodataScript(state.data)
    },
    CHANGE_MICRODATA: ({ commit, state }, data) => {
      commit('SET_MICRODATA', data)
      injectMicrodataScript(state.data)
    }
  }
}
